import * as React from 'react';
import { useAppStore } from '../stores';
import { ActionParams } from '../types';
import { ActionId, ContractActionContext, ContractActionHandler } from './ContractActionContext';

type SessionHandlerMap = Record<ActionId, (params?: ActionParams) => Promise<void>>;

const buildHandlers = (actionStore: ReturnType<typeof useAppStore>['actionStore']): SessionHandlerMap => ({
    ChangeBusinessType: () => actionStore.changeBusinessType(),
    AddLimit: params => actionStore.addLimit(params),
    AddDeduction: params => actionStore.addDeduction(params),
    RebuildNodes: () => actionStore.rebuildNodes(),
    SendContract: () => actionStore.sendContract(),
    ExportToJson: () => actionStore.exportToJson(),
    ClearPostAction: () => actionStore.clearPostAction(),
    InitializeContractIngestion: () => actionStore.initializeContractIngestion()
});

type Props = {
    children: React.ReactNode;
};

export const SessionActionProvider: React.FC<Props> = ({ children }) => {
    const { actionStore } = useAppStore();

    const handlers = React.useMemo(() => buildHandlers(actionStore), [actionStore]);

    const value = React.useMemo<ContractActionHandler>(
        () => ({
            async dispatch(actionId, params) {
                const handler = handlers[actionId];

                if (!handler) {
                    console.error(`[SessionActionProvider] Unknown action '${actionId}'`);
                    return;
                }

                await handler(params);
            }
        }),
        [handlers]
    );

    return <ContractActionContext.Provider value={value}>{children}</ContractActionContext.Provider>;
};
